import styled from 'styled-components';

export const ImgButton = styled.img`
  cursor: pointer;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
`;

